import { Button, TextField, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { axiosInstancePublic } from "../../services/axios-instance";
import { RESET_PASS_URL } from "../../services/endpoints";
import { useEffect } from "react";

export const ChangePassword = () => {
    const [password, setPassword] = useState<string>("");
    const [passwordConfirmation, setPasswordConfirmation] =
        useState<string>("");
    const [isPasswordChanged, setIsPasswordChanged] = useState<boolean>(false);

    const [passwordMatch, setPasswordMatch] = useState<boolean>(true); // State to track password match

    const [searchParams] = useSearchParams();
    const email = searchParams.get("email");
    const token = searchParams.get("token");

    const handleChangePassword = async (e: { preventDefault: () => void }) => {
        e.preventDefault();
        try {
            if (!email || !token || !password || !passwordConfirmation) {
                // throw new Error("Please provide all the required fields.");
            }

            const responseChangePassword = await axiosInstancePublic.post(
                RESET_PASS_URL,
                {
                    email,
                    token,
                    password,
                    password_confirmation: passwordConfirmation,
                }
            );

            // Handle the response as needed
            if (responseChangePassword.data.success) {
                setIsPasswordChanged(true);
            }
        } catch (error) {
            // Handle errors
            console.error(error);
        }
    };

    useEffect(() => {
        // Check if the passwords match whenever either password or passwordConfirmation changes
        setPasswordMatch(password === passwordConfirmation);
    }, [password, passwordConfirmation]);

    useEffect(() => {
        let timer: any;
        if (isPasswordChanged) {
            timer = setTimeout(() => {
                setIsPasswordChanged(false);
            }, 4000);
        }
        return () => clearTimeout(timer);
    }, [isPasswordChanged]);

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Typography component="h1" variant="h5">
                    Reset your password
                </Typography>
                <Box
                    component="form"
                    onSubmit={handleChangePassword}
                    noValidate
                    sx={{ mt: 1 }}
                >
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="username"
                        label="Password"
                        name="username"
                        autoComplete="username"
                        autoFocus
                        value={password} // Set the current value of the TextField
                        onChange={(e) => setPassword(e.target.value)} // Update the emailAddress state on change
                    />

                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="username"
                        label="Confirmation Password"
                        name="username"
                        autoComplete="username"
                        autoFocus
                        value={passwordConfirmation} // Set the current value of the TextField
                        onChange={(e) =>
                            setPasswordConfirmation(e.target.value)
                        } // Update the emailAddress state on change
                        helperText={!passwordMatch && "Passwords do not match"}
                    />

                    {isPasswordChanged && (
                        <Typography
                            component="h1"
                            variant="body1"
                            sx={{ mt: 1, color: "green" }}
                        >
                            Your password has been changed successfully. Please
                            return to the login page to sign in by clicking
                            <a href="/"> here</a>.
                        </Typography>
                    )}

                    <Button
                        type="submit"
                        color="warning"
                        fullWidth
                        variant="contained"
                        disabled={!passwordMatch}
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Reset
                    </Button>
                </Box>
            </Box>
        </Container>
    );
};
